import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { _HttpClient, SettingsService } from '@delon/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'app-trial-banner',
  standalone: true,
  imports: [],
  templateUrl: './trial-banner.component.html',
  styleUrls: ['./trial-banner.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrialBannerComponent implements OnInit {
  readonly #http = inject(_HttpClient);
  readonly #router = inject(Router);
  readonly #settingsService = inject(SettingsService);
  license = signal<any>(null);

  isFreeTrail = signal(false);
  isLicensed = signal(false);
  isDemo = computed(
    () =>
      !!this.#settingsService.user['company']?.isSample ||
      !!this.license()?.isSample
  );
  daysUntilReset = computed(() => this.#daysUntilNextMonthlyReset());
  showBanner = computed(() => this.isFreeTrail() || !this.isLicensed() || this.isDemo());
  isCollapsed = signal(false);

  #daysUntilNextMonthlyReset(): number {
    const today = new Date();
    const dayOfMonth = today.getDate();
    if (dayOfMonth === 1) {
      return 0;
    }
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), dayOfMonth);
    const nextReset = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    return Math.round((nextReset.getTime() - startOfToday.getTime()) / 86400000);
  }

  get planLink() {
    return `/account/subscription/subscribe/${this.#settingsService.user['company']['tenantId']}`;
  }



  ngOnInit() {
    this.#http.get('api/license/mylicense').subscribe(result => {
      this.license.set(result);
    });
    this.isFreeTrail.set(this.#settingsService.user['company']['isFreeTrial']);
    this.isLicensed.set(this.#settingsService.user['company']['licensed']);

    this.#settingsService.notify.subscribe(({ name, value }) => {
      if (name === 'collapsed') {
        this.isCollapsed.set(value as boolean);
      }
    });
  }

  navigateToPlan() {
    this.#router.navigateByUrl(this.planLink);
  }

  navigateToMyCompanies(){
    this.#router.navigate(['/account/companies/active']);
  }
}
